<template>
  <v-app id="inspire" class="bodyPadding privilegesScreen"> 
    <mo-header></mo-header>
    <v-content>
		<privilege-head></privilege-head>		
		<privilege-list></privilege-list>
    </v-content>
  </v-app>
</template>

<script>

	import PrivilegeHead from './Header.vue';	
	import PrivilegeList from './List.vue';	
	import { mapGetters } from 'vuex'; 
	
	export default {
		data () {
			return {
		
			}		
		},
		components: {
          PrivilegeHead,		
          PrivilegeList
		},
		computed: {
			...mapGetters([			
				'objAuthorize',
			])
		},
		created() {
			if( this.objAuthorize.privileges.indexOf('VIEW_PRIVILEGES') === -1 ) {
				this.$router.replace('/');
			}			
		}	
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>